import { suggestBoardFeed } from "./suggestBoardFeed";
import type { ResolveBoardFeeds, ResolvedBoardFeed } from "./types";

export const resolveBoardFeeds: ResolveBoardFeeds = ({ sources, stored }) => {
  const resolved: Record<string, ResolvedBoardFeed> = {};
  sources.forEach((source) => {
    const yours = stored[source.label];
    if (yours) {
      resolved[source.label] = { from: "yours", feed: yours };
      return;
    }
    const { feed, reason } = suggestBoardFeed(source);
    resolved[source.label] = { from: "suggested", feed, reason };
  });
  return resolved;
};
